import { SETTABLE, TABLE_ERROR, REMOVETABLE, WAITER_CALLED, SET_CONTINUE_ORDERING } from "../actionTypes";
const table_number = localStorage.getItem("table_number");

const initialState = {
    table: table_number ? table_number : false,
    waiterCalled: localStorage.getItem("iswaitercalled"),
    isContinueOrder: localStorage.getItem("isContinueOrder"),
};

export default function (state = initialState, action) {
    switch (action.type) {
        case SETTABLE:
            {
                return {
                    ...state,
                    table: action.payload
                }
            }
        case TABLE_ERROR: {
            return {
                ...state,
                error: action.payload
            }
        }
        case REMOVETABLE: {
            return {
                ...state,
                table: ""
            }
        }
        case WAITER_CALLED: {
            return {
                ...state,
                waiterCalled: action.payload
            }
        }
        case SET_CONTINUE_ORDERING: {
            return {
                ...state,
                isContinueOrder: action.payload
            }

        }

        default:
            return state;
    }
}








